/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import { useShoppingCart } from "@/context/ShoppingCartContext";
import { useLoader } from "@/hooks/utilHooks";
import { LinkUtils } from "@/utils/linkUtils";
import { sanitizeText } from "@/utils/string";
import { Button, CircularProgress } from "@mui/material";

import { styles } from "./styles";
import { CartButtonProps } from "./type";

const TitleFromType: Record<string, string> = {
  RESGATE: "RESGATAR VOUCHER",
  SITE: "IR PARA O SITE",
  INFORMATIVO: "TROQUE SEUS PONTOS KMV"
};

export const CardButton: React.FC<CartButtonProps> = ({
  title,
  buttonType,
  categoryId,
  partnerId,
  productId,
  buttonUrl,
  cardUrl,
  buttonProps,
  dispatchGtagEvent,
  partnerName,
  cardTitle,
  parentPartnerName
}) => {
  const { addItemToCart } = useShoppingCart();
  const { hideLoader, loading, showLoader } = useLoader();

  const buttonTitle = title ?? TitleFromType[buttonType ?? ""];

  return (
    <Button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        if (loading) {
          return;
        }

        if (buttonType === "RESGATE") {
          showLoader();
          addItemToCart({ categoryId, partnerId, productId }).finally(hideLoader);
        } else {
          LinkUtils.openLink(buttonUrl ?? cardUrl ?? "");
        }

        if (dispatchGtagEvent && partnerName && cardTitle) {
          try {
            const sanitizedPartner = sanitizeText(partnerName);
            const sanitizedCardTitle = sanitizeText(cardTitle);
            const sanitizedButtonTitle = sanitizeText(buttonTitle);
            const sanitizedParentPartnerName = sanitizeText(parentPartnerName ?? "");

            if ((window as any).dataLayer) {
              (window as any).dataLayer.push({
                event: "cta_parceiro",
                detail: `${sanitizedButtonTitle}:${sanitizedCardTitle}`,
                description: `parceiro:${sanitizedParentPartnerName}`,
                parceiro: sanitizedPartner
              });
              console.log(`Evento disparado: ${sanitizedButtonTitle}:${sanitizedCardTitle}`);
            }
          } catch (error) {
            console.error("Erro ao enviar o evento para o Google Tag Manager", error);
          }
        }
      }}
      size="medium"
      variant="contained"
      fullWidth={false}
      css={styles.button}
      disabled={loading}
      {...buttonProps}
    >
      {loading ? <CircularProgress size="small" sx={{ width: 24, height: 24, mr: 2, color: "#FFFFFF" }} /> : null}

      {buttonTitle}
    </Button>
  );
};
